import { Link } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { IconInfoFill, Text, XStack, tokens } from '@fhs/ui';

import { HomeAlertProps } from './types';

export function HomeAlert({ text, link, ...xStackProps }: HomeAlertProps) {
  const alertAccessibilityLabel = link ? `${text}. ${link.text}` : text;

  return (
    <XStack
      {...xStackProps}
      style={[styles.container, xStackProps.style]}
      accessible={!link}
      accessibilityRole="text"
      accessibilityLabel={!link ? alertAccessibilityLabel : undefined}
    >
      <View accessible={false} accessibilityElementsHidden>
        <IconInfoFill size={20} color="white" aria-hidden />
      </View>
      <View style={styles.messageContainer}>
        <Text accessible={false} style={styles.text}>
          {text}
        </Text>
      </View>
      {link && (
        <View style={styles.action} testID="mobile-home-alert-link">
          <Link
            href={link.href}
            accessibilityRole="link"
            accessibilityLabel={`${link.text}. ${text}`}
          >
            <Text accessible={false} style={[styles.text, styles.actionText]}>
              {link.text}
            </Text>
          </Link>
        </View>
      )}
    </XStack>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: tokens.colors.$houseDark,
    paddingHorizontal: 16,
    paddingVertical: 12,
    gap: 8,
    justifyContent: 'flex-start',
    maxWidth: '100%',
    alignItems: 'center',
  },
  messageContainer: {
    flexGrow: 1,
    flexShrink: 1,
    wordWrap: 'wrap',
  },
  text: { color: tokens.colors.$white },
  action: {
    marginLeft: 'auto',
  },
  actionText: {
    textDecorationLine: 'underline',
  },
});
